import React from 'react';


const InputErrors = ({ errors }) => {


    return (
        <div>
            {errors.length > 0 ? <div className="alert alert-warning mt-3" role="alert">
                {errors.map((txt, index) => <p key={index}>{txt}</p>)}
            </div> : null}
        </div>
    );
}

export default InputErrors;